import { Directive, Input, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { AuthService } from './../services/auth.service';

@Directive({
  selector: '[appHasRole]'
})
export class CheckRoleDirective implements OnInit {
  // the role the user must have
  @Input() public appHasRole: string;

  isVisible = false;
  companyRoles: any;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.updateView();
  }

  updateView() {
    const companyRoles = this.companyRoles ? this.companyRoles : this.authService.getCompanyRoles();
    if (!companyRoles || companyRoles === '') {
      this.isVisible = false;
      this.viewContainerRef.clear();
    } else {
      if (companyRoles === 'owner' || companyRoles === this.appHasRole) {
        this.isVisible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.isVisible = false;
        this.viewContainerRef.clear();
      }
    }
  }

}
